.scaleGrid {
  display: grid;
  grid-template-columns: repeat(11, minmax(0, 1fr));
  gap: 4px;
  width: 100%;
}

.scaleButton {
  min-width: 0;
  width: 100%;
  padding-inline: 0;
  padding-block: 6px;
  font-size: 0.8125rem;
  font-variant-numeric: tabular-nums;
}
